import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({error, errorInfo});
    }

    render() {
        if (this.state.hasError) {
            if (this.props.boundaryName) {
                return (
                    <div align="center">
                        <h4> Error caught in {this.props.boundaryName}. </h4>
                    </div>
                );
            } else {
                return (
                    <div align="center">
                        <h4> Something went wrong in this component! </h4>
                    </div>
                );
            }
        }
        return this.props.children;
    }
}

export default ErrorBoundary;